import styled from 'styled-components';
import Select from 'react-select';

export default styled(Select).attrs({ classNamePrefix: 'select' })`
  margin-bottom: 1em;
  padding: 0 !important;
  position: relative !important;

  .select {
    &__control {
      background-color: white;
      border-color: transparent;
      border-radius: .25em;
      box-shadow: ${props => props.theme.shadows.hover};
      cursor: pointer;
      outline: none;
      transition: box-shadow, transform, background-color;
      transition-duration: 250ms;

      &--menu-is-open {
        border-radius: .25em .25em 0 0;
      }
    }

    &__indicator-separator {
      display: none;
    }

    &__menu {
      border-radius: 0 0 .25em .25em;
      box-shadow: ${props => props.theme.shadows.hover};
      margin: -.0625em 0 0;
      z-index: 10;
      color: #333;//${({ theme }) => theme.colors.background.primary};
    }

    &__option {
      &--is-focused {
        background: #dfdfdf;
      }

      &--is-selected {
        background: ${props => props.theme.colors.primary};
        color: white;
      }
    }
  }
`;
